import { useEffect, useState } from "react";
import axios from "axios";

const useCurrencies = () => {
  const [currencies, setCurrencies] = useState([]); // Make sure this is initialized as an empty array

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await axios.get(
          "https://openexchangerates.org/api/currencies.json"
        );

        // Convert the response into an array of objects with 'code' and 'label'
        const currencyList = Object.keys(response.data).map((code) => ({
          code,
          label: `${code} - ${response.data[code]}`,
        }));

        setCurrencies(currencyList);
      } catch (error) {
        console.error("Error fetching currencies:", error);
        // Handle error, if necessary
      }
    };

    fetchCurrencies();
  }, []); // Empty dependency array ensures this runs once on mount

  return { currencies };
};

export default useCurrencies;
